module.exports = __webpack_public_path__ + "img/wqq-promo.351a19cd.jpg";